// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_aj-2";
export var aiChatCartContainerExit = "_aj-4";
export var aiChatContainerLarge = "_aj-0";
export var aiChatContainerSmall = "_aj-1";
export var aiChatIcon = "_aj-6";
export var slideInFromRight = "_aj-3";
export var slideOutToRight = "_aj-5";